// Background / foreground stem tracks stored on projectState.media.stems.

export const STEM_KINDS = ["background", "foreground"];

/**
 * Playable URL for a stem path. Local file paths become file:// URLs (the
 * Electron window runs without web security); URLs pass through unchanged.
 *
 * @param {string} localPath
 * @returns {string}
 */
export function toMediaUrl(localPath) {
    if (!localPath) return "";
    if (/^(https?|blob|file|data):/i.test(localPath)) return localPath;

    const normalized = localPath.replace(/\\/g, "/");
    const withRoot = normalized.startsWith("/") ? normalized : `/${normalized}`;
    return `file://${encodeURI(withRoot).replace(/#/g, "%23").replace(/\?/g, "%3F")}`;
}

/**
 * Ensures projectState.media.stems exists (projects saved before stems were added lack it).
 *
 * @param {object} media
 * @returns {{ background: { name: string, localPath: string }, foreground: { name: string, localPath: string } }}
 */
export function ensureStems(media) {
    if (!media.stems) {
        media.stems = {};
    }
    STEM_KINDS.forEach((kind) => {
        if (!media.stems[kind]) {
            media.stems[kind] = { name: "", localPath: "" };
        }
    });
    return media.stems;
}

export function hasStem(media, kind) {
    return Boolean(media?.stems?.[kind]?.localPath);
}
